import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const ndlFlowRunsSlice = createCrudSlice({
  name: 'ndlFlowRuns',
  idKey: 'id',
  reducers: {
    watchNdlFlowRunsRequest: (state) => {
      return { ...state, fetching: true }
    },
    unwatchNdlFlowRunsRequest: (state) => {
      return { ...state, fetching: false }
    },
  },
})

export const NdlFlowRunsActions = ndlFlowRunsSlice.actions

export const NdlFlowRunsSelectors = {
  ...createCrudSelectors({ name: 'ndlFlowRuns', idKey: 'id' }),
}

export default ndlFlowRunsSlice.reducer
